var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumber4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 249.3 179",
    style: {
      enableBackground: "new 0 0 249.3 179"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EB2D2A;}\r\n\t.st1{fill:#0D203B;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.1,99.5h-8.4c0-2.2-0.1-4.2-0.2-5.8c-0.1-0.8-0.8-1.4-1.6-1.3c-0.8,0-1.4,0.6-1.4,1.4c0,0.1,0,0.1,0,0.2 c0.2,2,0.2,3.9,0.3,5.6h-9.1v-7.9c0-0.8-0.7-1.5-1.5-1.5l0,0c-0.8,0-1.5,0.7-1.5,1.5v7.9h-15.5V78.1h-38.5v22H98.6l54-77h-42.1 l-60.2,83v26h69.5v25h39v-25h19v-29.5h8.9c0,1.1-0.1,2.1-0.2,3.2c-2.5,2.1-4.3,4.6-3.5,7.3c0.7,2.5,2,2.8,2.9,2.6 c2-0.4,3-3.9,3.4-8.3c2.9-2,6-3.7,9.3-5c0.6-0.2,1-0.8,1-1.4C199.6,100.2,198.9,99.6,198.1,99.5z M174.8,129.1h-19v25h-33v-25H53.3 v-22l58.8-81H147l-54,77h30.9v-22h32.5v21.5h18.5L174.8,129.1L174.8,129.1z M189.6,103.5v-1h1.7 C190.7,102.8,190.1,103.2,189.6,103.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.5,97.2h-8.4c0-2.2-0.1-4.2-0.2-5.8c-0.1-0.8-0.8-1.4-1.6-1.3c-0.8,0-1.4,0.6-1.4,1.4c0,0.1,0,0.1,0,0.2 c0.2,2,0.2,3.9,0.3,5.6h-9.1v-7.9c0-0.8-0.7-1.5-1.5-1.5l0,0c-0.8,0-1.5,0.7-1.5,1.5v7.9h-15.5V75.8h-38.5v22H101l54-77h-42.1 l-60.2,83v26h69.5v25h39v-25h19v-29.5h8.9c0,1.1-0.1,2.1-0.2,3.2c-2.5,2.1-4.3,4.6-3.5,7.3c0.7,2.5,2,2.8,2.9,2.6 c2-0.4,3-3.9,3.4-8.3c2.9-2,6-3.7,9.3-5c0.6-0.2,1-0.8,1-1.4C202,97.9,201.4,97.3,200.5,97.2L200.5,97.2z M177.1,126.7h-19v25h-33 v-25H55.6v-22l58.8-81h34.9l-54,77h30.9v-22h32.4v21.5h18.5L177.1,126.7L177.1,126.7z M191.9,101.1v-1h1.7 C193.1,100.4,192.5,100.8,191.9,101.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber4);
export default __webpack_public_path__ + "static/media/number-4.f9ee87b82b64b8a6a3ef9290f4b3a970.svg";
export { ForwardRef as ReactComponent };